import axios from "../lib/axios";
import React, { useEffect, useState } from "react"
import ReactLoading from 'react-loading';
import Layout from "../components/layout/Layout"

const basename= `${process.env.NODE_ENV == "development" ? 'http://localhost:3000' : 'https://www.piano-piano.org/oppdb'}`

const createSitemap = (composers, works) => {
    var doc = document.implementation.createDocument('', '', null);
    //create the outer tag
    var urlset = doc.createElement("urlset");
    urlset.setAttribute("xmlns", "http://www.sitemaps.org/schemas/sitemap/0.9");
    var url = ''; var changefreq = ''; var loc = '';
 
    //append dynamic user urls
    for (var i=0; i < composers.length; i++) {
        url = doc.createElement("url");
        loc = doc.createElement('loc');
        loc.innerHTML = `${basename}${"/?cmp="}` + composers[i].id + '_' + composers[i].firstName + '_' + composers[i].lastName;
        changefreq = doc.createElement("changefreq");
        changefreq.innerHTML = 'weekly';
        url.appendChild(loc);
        url.appendChild(changefreq);
        urlset.appendChild(url);
    }  
    
    //append dynamic user urls
    for (var i=0; i < works.length; i++) {
      url = doc.createElement("url");
      loc = doc.createElement('loc');
      loc.innerHTML = `${basename}${"/work/"}` + works[i].id + '/' + works[i].title;
      changefreq = doc.createElement("changefreq");
      changefreq.innerHTML = 'weekly';
      url.appendChild(loc);
      url.appendChild(changefreq);
      urlset.appendChild(url);
  }  
  
    doc.appendChild(urlset);
    //serialize the xml file to txt
    var oSerializer = new XMLSerializer();
    var xmltext = oSerializer.serializeToString(doc);
    xmltext = '<?xml version="1.0" encoding="UTF-8"?>' + xmltext;
    //download the txt
    var pom = document.createElement('a');
    var filename = "sitemap.xml";
    var pom = document.createElement('a');
    var bb = new Blob([xmltext], {type: 'text/plain'});
    pom.setAttribute('href', window.URL.createObjectURL(bb));
    pom.setAttribute('download', filename);
    pom.dataset.downloadurl = ['text/plain', pom.download, pom.href].join(':');
    pom.draggable = true; 
    pom.classList.add('dragout');
    pom.click();
}

const CreateSitemap = () => {

    // Initial state
    const [allWorks, setAllWorks] = useState([]),
          [allComposers, setAllComposers] = useState([]);

    useEffect(async() => {

        let mounted = true;

        await axios.get('/display-oeuvre').then((res) => {
            if (mounted) {
                setAllWorks(res.data.data);
            }
        })

        await axios.get('/display-composers').then((res) => {
            if (mounted) {
                setAllComposers(res.data.data);
            }
        });

        return () => {
            mounted = false;
        }
    }, []);

    useEffect(() => {
        if (allComposers.length > 0 && allWorks.length > 0) {
            console.log("allComposers", allComposers);
            console.log("allWorks", allWorks);
            createSitemap(allComposers, allWorks);
        }
    }, [allComposers, allWorks]);

    return (
        <Layout>
            <div className="w-full px-4 md:px-32 bg-white my-32 w-auto flex flex-row items-center">

                <h1 className="order-1 text-2xl my-4 md:text-3xl text-gray-500 font-bold ml-4">Wait for creating sitemap </h1>
                
                <div>
                    <ReactLoading type={"spin"} color={"#0047BA"} height={50} width={50} />
                </div>

            </div>
        </Layout>
    )
}

export default CreateSitemap
